import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBSpinner } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router';
import AddSMSCampaign from '../../components/topviews/addSMSCampaign';
import { getSMSCampaign, getSpecificSMSCampDetails } from '../../apiclients/streamsapi_bridge';
import DeleteSMSCampaign from '../popups/globalaccount/brandAndSMS/DeleteSMSCampaign';
import PopupLoaderNew from '../popups/PopupLoaderNew';
import { Tooltip } from 'react-tooltip';
import SmsCompliance from './SmsCompliance';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../../apiclients/UIConstant';
import TabIDConstant from '../../apiclients/TabIDConstant';

function SMSCampaign({ basicActive }) {
    const navigate = useNavigate();
    const [centredModal4, setCentredModal4] = useState(false);

    const toggleOpen4 = () => setCentredModal4(!centredModal4);
    const [internalError, setInternalError] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [SMSCampaigns, setSMSCampaigns] = useState([])
    const [deleteCampaign, setdeleteCampaign] = useState(false);
    const deletetoggle = () => setdeleteCampaign(!deleteCampaign);
    const [campaignObj, setcampaignObj] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const deletCampRef = useRef(null);
    const [draftDetails, setdraftDetails] = useState({})
    const [isDraft, setisDraft] = useState(false);
    const [smsCampaignDetails, setSmsCampaignDetails] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filteredIndices, setFilteredIndices] = useState([]);
    const [cnperror, setcnperror] = useState("");
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, basicActive)
    const handleManualSearch = (value) => {
        setSearchValue(value);

        if (!smsCampaignDetails || smsCampaignDetails.length === 0) {
            setFilteredIndices([]);
            return;
        }

        if (!value.trim()) {
            setFilteredIndices(smsCampaignDetails.map((_, i) => i));
            return;
        }

        const filterResult = customSearch(smsCampaignDetails, value, UIConstant.SMS_CAMPAIGNS);
        const matchingIndices = filterResult
            .map(filteredItem => smsCampaignDetails.indexOf(filteredItem))
            .filter(i => i !== -1);
        setFilteredIndices(matchingIndices);
    };
    function handleClick() {
        deletCampRef.current.click();
    }

    const showThisInfoSms = (tdata) => {
        if (!(tdata?.campInfo?.status?.toString() === "Saved As Draft")) {
            navigate("/smscampaignregistration", {
                state: tdata.campInfo
            });
        }
    }
    useEffect(() => {
        if (basicActive) {
            getSMSCampaigns();

        }

    }, [basicActive]);

    async function getSMSCampaigns() {
        try {
            setInternalError(false);
            setIsloading(true);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getSMSCampaign(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.SMS_CAMPAIGNS_SUBLINK
            );
            setIsloading(false);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("getSMSCampaigns data :::::::::: " + JSON.stringify(rawData));
            setSMSCampaigns(rawData?.sms_campaigns && Array.isArray(rawData?.sms_campaigns) ? rawData?.sms_campaigns : []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);


        } catch (error) {

        }
    }

    async function handleDaft(camp) {
        try {
            setIsloading(true);
            const response = await getSpecificSMSCampDetails(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                camp.campaignid
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            const campDetails = await response.json();
            console.log(
                "getSpecific campDetails ::: " +
                JSON.stringify(campDetails)
            );
            setisDraft(true);
            setdraftDetails(campDetails?.sms_campaigns ?? {});
            toggleOpen4();

        } catch (error) { }

    }

    useEffect(() => {
        let processdrows = [];
        SMSCampaigns.map((camp) => {

            processdrows.push({
                campInfo: camp,
                campaignName: camp?.campaign_name?.toString() ?? "",
                brandid: ((typeof camp?.brand_id === "string" && isNaN(Number(camp?.brand_id)))
                    ? camp?.brand_id
                    : ""),
                campaignID: camp?.apiCampaignId?.toString() ?? "",
                // store plain string for search
                campaignStatusText: camp?.status?.toString() ?? "",
                campaignStatus: (() => {
                    const raw = camp?.status ?? "";
                    const status = String(raw).trim();
                    const statusLower = status.toLowerCase();

                    return status === "Saved As Draft" ? (
                        <a onClick={(e) => { e.preventDefault(); handleDaft(camp); }}>
                            Saved As Draft
                        </a>
                    ) : status === "CNP Declined" ? (
                        <span className='text-danger'>
                            CNP Declined
                            <i
                                className="fa-regular fa-circle-question cnpToolTip ms-1"
                                title=''
                                onMouseOver={(e) => {
                                    e.preventDefault();
                                    setcnperror(camp?.error_description || "");
                                }}
                            ></i>
                        </span>
                    ) : (
                        <span className={statusLower === "pending" ? "text-primary" : ""}>
                            {status}
                            {(statusLower === "pending" || statusLower === "dca election pending" || statusLower === "dca complete") && (
                                <i
                                    className="fa-solid fa-circle-info cnpToolTip ms-1 text-secondary"
                                    title=''
                                    onMouseOver={(e) => {
                                        e.preventDefault();
                                        if (statusLower === "dca complete") {
                                            setcnperror("Phone numbers can only be added after 2 hours of campaign approval.");
                                        }
                                        else {
                                            setcnperror("Your brand website validation was successful. It will take 2–7 working days for final confirmation, and you’ll receive an email once it’s approved");
                                        }
                                    }}
                                ></i>
                            )}
                        </span>
                    );
                })(),

                count: (
                    <span>
                        {camp?.count ?? ""}
                        {/* {camp?.count > 0 || camp?.add_pending > 0 || camp?.add_reject > 0 && */}
                        {(camp?.count > 0 ||
                            camp?.add_pending > 0 || camp?.add_reject > 0 ||
                            camp?.remove_pending > 0 || camp?.remove_reject > 0 || camp?.sc_progress > 0
                        ) && (
                                <MDBIcon
                                    fas
                                    icon="info-circle"
                                    size="sm"
                                    title=""
                                    color="secondary"
                                    className="cnpToolTip2 ms-1"
                                    data-tooltip-id="tooltip-phone-count-details"
                                    data-tooltip-html={[
                                        // camp?.added_count > 0 &&
                                        // `Added Phone Number(s):<strong> ${camp.added_count} (Included)</strong>`,

                                        camp?.added_count > 0 && (
                                            camp?.sc_progress > 0
                                                ? `Campaign association is in progress Phone Number(s):<strong>${camp.added_count}</strong>`
                                                : `Added Phone Number(s):<strong>${camp.added_count} (Included)</strong>`
                                        ),

                                        camp?.add_pending > 0 &&
                                        `Add Request Pending Phone Number(s):<strong> ${camp.add_pending}</strong>`,

                                        camp?.add_reject > 0 &&
                                        `Add Request Rejected Phone Number(s):<strong> ${camp.add_reject}</strong>`,

                                        camp?.remove_pending > 0 &&
                                        `Delete Request Pending Phone Number(s):<strong> ${camp.remove_pending} (Included)</strong>`,

                                        camp?.remove_reject > 0 &&
                                        `Delete Request Rejected Phone Number(s):<strong> ${camp.remove_reject} (Included)</strong>`
                                    ]
                                        .filter(Boolean)
                                        .join("<br />")}
                                />

                            )}

                    </span>

                ),

                useCase: camp?.type?.toString() ?? "",
                verticalType: camp?.orgtype?.toString() ?? "",
                registeredOn: camp?.registeredOn?.toString() ?? "",
                // campaignDescription: camp?.camp_desc?.toString() ?? "",

                action: (
                    <>
                        <div className="d-flex align-items-center ms-2">
                            <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip"
                                onClick={(e) => handleDelete(e, camp)}
                            >
                                <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                            </div>
                        </div>
                    </>
                ),




            })
        })
        setSmsCampaignDetails(processdrows);
        setFilteredIndices(processdrows.map((_, i) => i));
        setDataLoaded(true)
    }, [SMSCampaigns])

    const basicData = {
        columns: [
            { label: "Campaign Name", field: "campaignName", sort: true },
            { label: "Brand ID", field: "brandid" },
            { label: "Campaign ID", field: "campaignID" },
            { label: "Campaign Status", field: "campaignStatus" },
            {
                label: (
                    <>
                        Phone Number(s) Count <MDBIcon fas icon="question-circle" color='secondary' title="" className="phoneCountToolTip" />
                    </>
                ), field: "count"
            },

            { label: "Use Case", field: "useCase" },
            { label: "Vertical Type", field: "verticalType" },
            { label: "Registered On", field: "registeredOn" },
            // { label: "Campaign Description", field: "campaignDescription" },
            { label: 'Remove', field: 'action', sort: false },
        ],
        rows: smsCampaignDetails,
    };

    function handleDelete(e, campObj) {
        e.preventDefault();
        e.stopPropagation();
        setcampaignObj(campObj);
        deletetoggle();
    }

    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td, table th');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        patchTitles();

        const table = document.querySelector('.campaignDataTable');

        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>

            <div className="d-flex align-items-center justify-content-between actionbar">
                {/* <div className='me-2'>

                    <MDBBtn className="ms-2 btn_adjust" onClick={toggleOpen4}>
                        Create SMS Campaign
                    </MDBBtn>
                </div> */}
            </div>
            <div className='mb-2 mt-0 position-relative w-auto'>
                <MDBInput
                    label="Search"
                    ref={searchRef}
                    value={searchValue}
                    onChange={(e) => handleManualSearch(e.target.value)}
                />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className="smsDataTable">
                <MDBDatatable key={searchValue}
                    //  search
                    data={{ ...basicData, rows: filteredIndices.map(i => smsCampaignDetails[i]) }} fixedHeader entries={50} className='actioncolumn campaignDataTable' onRowClick={(e) => showThisInfoSms(e)} />
            </div>

            {/* <MDBModal open={centredModal4} onClose={() => setCentredModal4(false)} tabIndex='-1'>
                <MDBModalDialog size="fullscreen" centered>
                    <MDBModalContent>
                        <MDBModalBody className="xl">
                            <SmsCompliance />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal> */}

            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

            {deleteCampaign && (
                <PopupLoaderNew
                    title={"Remove SMS Campaign"}
                    content={<DeleteSMSCampaign
                        campaignObj={campaignObj}
                        onClose={deletetoggle}
                        ref={deletCampRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setdeleteCampaign}
                    onClose={deletetoggle}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
            <Tooltip anchorSelect=".cnpToolTip" place="right" className="exampleTooltipLight" style={{ maxWidth: "25%" }}>
                {cnperror}
            </Tooltip>
            <Tooltip anchorSelect=".phoneCountToolTip" place="right" className="exampleTooltipLight" style={{ maxWidth: "25%" }}>
                Please note that only 49 phone numbers can be assigned per a campaign. Once the limit has been reached a new campaign will need to be registered.
            </Tooltip>
            <Tooltip id="tooltip-phone-count-details" place="right" className="exampleTooltipLight" />


        </>
    )
}

export default SMSCampaign
